(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player-solidtango/assets/javascripts/components/error.js') >= 0) return;  svs.modules.push('/components/racing/stream-player-solidtango/assets/javascripts/components/error.js');

'use strict';

const StreamPlayerSolidtangoError = _ref => {
  let {
    loadStreamingPlayer
  } = _ref;
  return React.createElement("div", {
    className: "stream-player-solidtango-error-container hasError"
  }, React.createElement("div", {
    className: "stream-player-solidtango-error-container-info"
  }, React.createElement("div", {
    className: "icon-holder margin-xs-bottom-1"
  }, React.createElement("i", {
    className: "icon icon-800 icon-inverted icon-help"
  })), React.createElement("div", {
    className: "text-information f-inverted f-600 margin-xs-bottom-2"
  }, "Just nu finns det ingen video tillg\xE4nglig."), React.createElement("div", {
    className: ""
  }, React.createElement("button", {
    className: "btn btn-300 btn-transparent-inverted",
    onClick: () => loadStreamingPlayer(),
    type: "button"
  }, "F\xD6RS\xD6K IGEN"))));
};
setGlobal('svs.components.racing.streamPlayerSolidtango.StreamPlayerSolidtangoError', StreamPlayerSolidtangoError);

 })(window);